import React, { FC } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IButton {
  text: string;
  value: string;
  isActive?: boolean;
  isDisabled?: boolean;
}

interface IProps {
  buttons: IButton[];
  className?: string;
  onTabClick: (button: IButton) => void;
}

const Tabs: FC<IProps> = ({ buttons, className, onTabClick }) => {
  return (
    <div className={classNames([css.tabs], className)}>
      {buttons.map((button) => (
        <button
          key={button.text}
          disabled={button.isDisabled}
          onClick={() => onTabClick(button)}
          className={classNames(css.tabs__button, {
            [css.isActive]: button.isActive,
            [css.isDisabled]: button.isDisabled,
          })}
        >
          {button.text}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
